/**
 * Llama al backend Spring Boot para obtener datos del usuario.
 * @param accessToken - Token de acceso de Azure AD (Entra ID)
 * @returns Claims del usuario desde el backend
 */
export const callBackend = async (accessToken: string): Promise<any> => {
  const response = await fetch("https://back-sqai-sandbox.sqai.ai/api/me", {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });

  if (!response.ok) {
    throw new Error(`Error al llamar backend: ${response.statusText}`);
  }

  return response.json();
};
